import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const getCategoryList = createAsyncThunk(
  "/getCategories",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}category/api/v1/getCategories`, data,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch categories"
      );
    }
  }
);

